export const routes = {
  home: '/',
  work: '/projects/',
  caseStudies: '/projects/case-studies/',
  caseStudy: ({ title }: { title: string }) =>
    `/projects/case-studies/${title.replace(/\s+/g, '-').replace(/\.+$/, '').replace(':', '').replace("'", '').replace(/,/g, '').toLowerCase()}`,
  solutions: '/solutions/',
  contact: '/contact',
  process: '/approach',
  privacyPolicy: '/privacy-policy',
  ideas: '/ideas/',
  idea: ({ slug }: { slug: string }) => `/ideas/${slug}`,
  // @TODO: Add it
  careers: '/careers',
  sectors: '/sectors',
  singleSector: ({ title }: { title: string }) =>
    `/sectors/${title?.replace(/\s+/g, '-').replace(/\.+$/, '').replace(':', '').replace("'", '').toLowerCase()}`,
  offices: '/offices',
  office: ({ slug }: { slug: string }) => `/offices/${slug?.toLowerCase()}`,
} as const;
